import { createApi } from '@/api'

export default {
  getModules: config => createApi(`/module/get`, 'get', config), // 获取模块
  saveModule: config => createApi(`/module/save`, 'post', config), // 保存模块
  deleteModule: config => createApi(`/module/delete?moduleId={id}`, 'post', config), // 删除模块
  batchDeleteModule: config => createApi(`/module/deleteBatch`, 'post', config) // 批量删除模块
}



// WEBPACK FOOTER //
// ./src/views/setting/api/index.js